export const templateOfTextBlock = `
    <p class="greytext--text">Enter an optional description here to explain the step in more detail...</p>
`
